<template>
  <section class="proposal-page__section branding-postcard">
    <article class="proposal-page__cut branding-postcard__black-cut">
      <div class="pp-container --is-narrow">
        <header class="proposal-page__section-heading">
          <h2 class="proposal-page__section-title">{{ data.content.postcard.title }}</h2>
          <p class="proposal-page__section-description">{{ data.content.postcard.description }}</p>
        </header>

        <div class="branding-postcard__spotlight">
          <div class="branding-postcard__wrapper">
            <img src="@/assets/images/proposal-page/handwritten-card.png" class="branding-postcard__postcard">

            <div class="branding-postcard__logo">
              <img :src="`${data.logo.sizes.medium}?format=png`" alt="Ihre Logo">
            </div>
          </div>
        </div>
      </div>
    </article>

    <article class="proposal-page__cut branding-postcard__gray-cut">
      <div class="pp-container">
        <ul class="branding-postcard__features">
          <li class="branding-postcard__feature">
            <div v-html="data.content.postcard.features.angebot_branding_postcard_feature1_icon"></div>

            <h3 class="branding-postcard__feature-title">{{ data.content.postcard.features.angebot_branding_postcard_feature1_title }}</h3>
            <p class="branding-postcard__feature-description">{{ data.content.postcard.features.angebot_branding_postcard_feature1_description }}</p>
          </li>

          <li class="branding-postcard__feature">
            <div v-html="data.content.postcard.features.angebot_branding_postcard_feature2_icon"></div>

            <h3 class="branding-postcard__feature-title">{{ data.content.postcard.features.angebot_branding_postcard_feature2_title }}</h3>
            <p class="branding-postcard__feature-description">{{ data.content.postcard.features.angebot_branding_postcard_feature2_description }}</p>
          </li>

          <li class="branding-postcard__feature">
            <div v-html="data.content.postcard.features.angebot_branding_postcard_feature3_icon"></div>

            <h3 class="branding-postcard__feature-title">{{ data.content.postcard.features.angebot_branding_postcard_feature3_title }}</h3>
            <p class="branding-postcard__feature-description">{{ data.content.postcard.features.angebot_branding_postcard_feature3_description }}</p>
          </li>
        </ul>
      </div>
    </article>
  </section>
</template>

<script>
import { helperMixin } from '@/mixins/HelperMixin';

export default {
  name: 'BrandingPostcard',
  mixins: [helperMixin],
  props: ['data']
};
</script>

<style lang="scss" scoped>
/**
 * BrandingPostcard
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc BrandingPostcard section
 * @since 2022-09-12
**/

.proposal-page__section-description {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}
.proposal-page__section-heading {
  @include margin-bottom(map-get($spacers, 4) !important);
}

$component: 'branding-postcard';

.#{$component} {
  color: #d4d8de;

  &__black-cut {
    background: radial-gradient(#212B36, #0f151b 100%);
  }

  &__gray-cut {
    @include padding-top(map-get($spacers, 4) * 3 !important);
    background: $ink;
  }

  // Spotlight
  &__spotlight {
    overflow: hidden;
    @include padding-top(map-get($spacers, 4));
  }

  &__wrapper {
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    width: 60%;
    height: auto;
    aspect-ratio: 1 / 1;
    margin: 0 auto;
    // @include margin-bottom(- map-get($spacers, 6) * 1);
    pointer-events: none;
    transform: rotate(-10deg);
  }

  &__postcard {
    width: 100%;
    height: auto;
    @include imageRendering;
  }

  &__logo {
    position: absolute;
    bottom: 16%;
    left: 27%;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    width: 24%;
    height: auto;
    pointer-events: none;
    z-index: 2;

    img {
      max-width: 100%;
      max-height: 60px;
      pointer-events: none;
      // @include imageRendering;
    }
  }

  // Features
  &__features {
    @include unlist;

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__feature {
    flex: 0 0 28%;

    svg {
      @include rfs(3.4rem, width);
      color: #d4d8de;
    }
  }

  &__feature-title {
    @include margin-top(map-get($spacers, 3));
    @include margin-bottom(map-get($spacers, 4));
    @include font-size(map-get($proposal-page, 'font-size-lg'));
    line-height: 130%;
  }

  &__feature-description {
    margin: 0;
    font-weight: $font-weight-lighter;
  }

  &__germany-text-mask {
    font-weight: $font-weight-bolder;
    // text-shadow: 1px 1px 4px lighten(#1C1C1C, 10%);
    background: linear-gradient(to right, #616161, #9a4756, #b7ac83);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-lg')) {
    &__logo img {
      max-height: 50px;
    }
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-md')) {
    @at-root .proposal-page__section-heading {
      @include margin-bottom(map-get($spacers, 4) !important);
    }

    &__logo img {
      max-height: 40px;
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-sm')) {
    &__features {
      @include margin-bottom(- map-get($spacers, 4) * 3)
    }

    &__feature {
      flex: 0 0 48%;
      @include margin-bottom(map-get($spacers, 4) * 3);
    }

    &__schuber {
      width: 80%;
    }

    @at-root .proposal-page__section-description {
      width: 100%;
    }
  }

  // ——————————————————————————————
  // XXS
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-xs')) {
    &__feature {
      flex: 0 0 100%;
      @include margin-bottom(map-get($spacers, 4) * 4);
    }
  }

  // ——————————————————————————————
  // XS
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-xs')) and (max-width: map-get($proposal-page, 'viewport-sm')) {
    &__logo img {
      max-height: 26px;
    }
  }

  // ——————————————————————————————
  // SM
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-sm')) and (max-width: map-get($proposal-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // MD
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-md')) and (max-width: map-get($proposal-page, 'viewport-lg')) {
  }
}
</style>
